import type { AllRouteEndpoints } from "../routeTypes";
export const appsBusinessUsersCacheKeys: AllRouteEndpoints[] = [];
